import {FieldArray} from 'redux-form'
import ItemVariantsFieldArray from './ItemVariantsFieldArray'

class ItemVariants extends React.Component {
  render () {
    let defaultValue = {price: undefined, sku: undefined}
    return <FieldArray
      name='item_variants'
      component={ItemVariantsFieldArray}
      defaultValue={defaultValue}
      placeholder='price'
    />
  }
}

export default ItemVariants



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemVariant/ItemVariants.js